import { render, staticRenderFns } from "./GreenTeaExtract.vue?vue&type=template&id=6184623f&scoped=true&"
import script from "./GreenTeaExtract.vue?vue&type=script&lang=js&"
export * from "./GreenTeaExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6184623f",
  null
  
)

export default component.exports